import { createRouter, createWebHistory } from "vue-router";
import {
	CometChatUI
} from "../cometchat-pro-vue-ui-kit/CometChatWorkspace/src";

const routes = [
  { path: "/", component: CometChatUI },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
